import React, { useCallback, useState } from 'react';
import cn from 'classnames/bind';
import { Picture, createPictureFactory } from '@funtech-int/yango-shared';

import styles from './StaticCover.module.css';

const cx = cn.bind(styles);

const pictureFactory = createPictureFactory({
    fallback: {
        srcSet: {
            '1x': '1920x1080_95q',
            '2x': '3840x2160',
        },
        src: '1920x1080_95q',
    },
});

interface StaticCoverProps {
    className?: string;
    backgroundUrl: string;
    withAdditionalGradient?: boolean;
    customOverlayStyles?: string;
}

export const StaticCover = ({
    className,
    backgroundUrl,
    withAdditionalGradient = false,
    customOverlayStyles = undefined,
}: StaticCoverProps) => {
    const [isFailed, setIsFailed] = useState(false);

    const onError = useCallback(() => setIsFailed(true), []);

    const { img } = pictureFactory({
        fallbackUrl: backgroundUrl,
    });

    if (isFailed || !backgroundUrl || backgroundUrl === '') {
        return null;
    }

    return (
        <>
            <Picture
                className={cx('root', className)}
                alt=""
                loading="lazy"
                srcSet={img.srcSet}
                src={img.src}
                onError={onError}
                data-tid="AdaptiveImage"
            />
            {customOverlayStyles ? (
                <div className={cx(customOverlayStyles)} />
            ) : (
                <div className={cx('overlay')} />
            )}
            {withAdditionalGradient && <div className={cx('additionalGradient')} />}
        </>
    );
};
